import React from 'react';
import useTable from '@hooks/useTable';

import { Row, Col } from 'react-bootstrap';
import { Table, Input } from 'antd';

export default function PageNetwork() {
    const { dataSource, handleSearched } = useTable('/network/');

    const columns = [
        {
            title: 'Geral',
            render: data => (
                <>
                    <div><b>Nome:</b> {data.nome}</div>
                    <div><b>Responsável:</b> {data.nome_contato}</div>
                    <div><b>Contato:</b> {data.telefone} {data.email}</div>
                </>
            )
        }, {
            title: 'Ação',
            key: 'acao',
            align: 'right',
            width: '30%',
            render: data => (
                <a href={`/redes/update/${data.id_network}`} className="btn btn-primary">
                    <i className="icon-note" /> Editar
                </a>
            )
        }
    ];

    return (
        <div className="bg-padrao">
            <Row>
                <Col md="6">
                    <h1>Rede de clientes</h1>
                </Col>
                <Col md="6" className="text-right">
                    <a href="/redes/create" className="btn btn-success">
                        <i className="icon-plus"></i>
                        Cadastrar Nova
                    </a>
                </Col>
            </Row>
            <div className="hardLine"></div>
            <Row className="justify-content-end">
                <Col md="3">
                    <div className="input-icon">
                        <Input onChange={handleSearched} placeholder="Procurar" />
                        <i className="icon-magnifier" />
                    </div>
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={dataSource.dataTable}
                loading={dataSource.loading}
                pagination={{ pageSize: 20 }}
            />
        </div>
    )
}
